var unsaved = false;

function get_wastages_for_ingredient(ingredient_id, callback, prev_value = false) {
    var ing_field_name = 'ingredient_wastage_id[]';
    var url = '/admin/ingredient_wastages/get_dropdown/' + ingredient_id + '/' + encodeURIComponent(ing_field_name);

    if(prev_value > 0) {
        url += '/' + prev_value
    }

    //Load in the ingredient wastages
    ajax_call('get', url, {}, callback);

}

function get_units_for_ingredient(ingredient_id, callback, prev_value = false) {
    var ing_field_name = 'ingredient_unit[]';
    var url = '/admin/ingredient_units/get_dropdown/' + ingredient_id + '/' + encodeURIComponent(ing_field_name);

    if(prev_value) {
        url += '/' + prev_value
    }

    //Load in the ingredient units
    ajax_call('get', url, {}, callback);

}

function get_units_for_recipe(recipe_id, callback, field_name) {
    if(field_name === undefined) {
        field_name = 'recipe_unit[]';
    }

    //Load in the recipe units
    ajax_call('get', '/admin/recipe_units/get_dropdown/' + recipe_id + '/' + encodeURIComponent(field_name), {}, callback);

}

$(function() {
    //Show form save button on DOM ready
    $('button[type="submit"]').css('visibility', 'visible');

    //Search clear X for listing form
    $body.on('click', '.listing-filter .search__close', function(e) {
        e.preventDefault();
        $('input[name="phrase"]').val('');
        $('.listing-filter .search__close').hide();
        $('.listing-filter .search__loading').show();

        var data = get_listing_data(1);
        get_listing(data);
    });

    //Save form buttons
    $body.on('click', '.save-form', function(e) {
        e.preventDefault();

        var form_id =  $(this).data('form');

        //Trigger form submission
        $("#" + form_id).submit();
    });

    //When deleting item
    $('body').on('click', '.ingredient-container .actions > span.negative, ' +
        '.measurement-container .actions > span.negative, ' +
        '.wastage-container .actions > span.negative, ' +
        '.recipe-container .actions > span.negative, ' +
        '.stocktake-container .actions > span.negative', function(e) {
        e.preventDefault();

        //Temp confirm window for deleting
        if(confirm(lang['confirm_delete'])) {
            var $row = $(this).closest('.row');
            $row.remove();
        }

    });

    //Delete list item
    $body.on('click', '.delete-item', function(e) {
        e.preventDefault();

        var action = 'delete';
        var context = $(this).data('context');
        var id = $(this).data('id');
        var perm_delete = !!$(this).data('perm-delete');

        if(perm_delete) {
            action = 'perm_delete';
        }

        //Confirm they want to delete
        if(confirm(lang['confirm_delete'])) {

            //Make ajax call to save data
            ajax_call('post', '/admin/' + context + '/bulk_action/' + action, {ids: id}, function(response) {

                //If successful...
                if(response.response) {

                    //Reload listing
                    var data = get_listing_data();
                    get_listing(data);

                    //Show success message
                    alert(response.message);

                //Otherwise there's an error
                } else {

                    //Show alert with error message/s
                    alert(response.message);

                }

            });

        }

    });

    //Delete item from view page
    $body.on('click', '.delete-view-item', function(e) {
        e.preventDefault();

        var action = 'delete';
        var context = $(this).data('context');
        var id = $(this).data('id');
        var perm_delete = !!$(this).data('perm-delete');

        if(perm_delete) {
            action = 'perm_delete';
        }

        //Confirm they want to delete
        if(confirm(lang['confirm_delete'])) {

            //Make ajax call to save data
            ajax_call('post', '/admin/' + context + '/bulk_action/' + action, {ids: id}, function(response) {

                //If successful...
                if(response.response) {

                    //Show success message
                    alert(response.message);

                    //Go to list view for this type of item
                    console.log('/admin/' + context);
                    window.location = '/admin/' + context;

                //Otherwise there's an error
                } else {

                    //Show alert with error message/s
                    alert(response.message);

                }

            });

        }

    });

    //Duplicate item
    $body.on('click', '.duplicate-item', function(e) {
        e.preventDefault();

        var action = 'duplicate';
        var context = $(this).data('context');
        var id = $(this).data('id');

        //Confirm they want to duplicate
        if(confirm(lang['confirm_duplicate'])) {

            //Make ajax call to save data
            ajax_call('post', '/admin/' + context + '/bulk_action/' + action, {ids: id}, function(response) {

                //If successful...
                if(response.response) {

                    //Go to edit view for this item
                    window.location = '/admin/' + context + '/edit/' + response.new_id + '/1';

                //Otherwise there's an error
                } else {

                    //Show alert with error message/s
                    alert(response.message);

                }

            });

        }

    });

    //Resend Activation Email button
    $body.on('click', '.resend-activation', function(e) {
        e.preventDefault();

        var $btn = $(this);
        var id = $(this).data('id');
        var ref = $(this).data('ref');

        //Confirm they want to delete
        if(confirm(lang['confirm_resend_activation'])) {

            //Grey out the button while we're saving...
            $btn.attr('disabled', 'disabled');

            //Make ajax call to save data
            ajax_call('post', '/admin/users/bulk_action/resend_activation', {ids: id, account_reference: ref}, function(response) {

                //If successful...
                if(response.response) {

                    //Show success message
                    alert(response.message);

                //Otherwise there's an error
                } else {

                    //Reenable button on error
                    $btn.removeAttr('disabled');

                    //Show alert with error message/s
                    alert(response.message);

                }

            });

        }

    });

    //General form AJAX submits
    $body.on('submit', '.ajax-form', function(e) {
        e.preventDefault();

        //Get form data
        var data = $(this).serializeArray();
        var context = $(this).attr('id');
        var $form = $(this);

        //Grey out all submit buttons while we're saving...
        $('button[type="submit"]').attr('disabled', 'disabled');

        //Make ajax call to save data
        ajax_call('post', $(this).attr('action'), data, function(response) {

            //Reenable all submit buttons after save complete
            $('button[type="submit"]').removeAttr('disabled');

            //Clear error classes
            $('input, select, textarea, .chosen-container').removeClass('field-error');

            //If successful...
            if(response.response) {
                unsaved = false;

                //Check for redirect
                if(response.redirect) {
                    window.location = response.redirect;

                } else {

                    //For ingredient pop-up form only... (from within recipe page)
                    if(context === 'popup-ingredient-form' && response.body) {

                        //Add new ingredient to all dropdowns on this page
                        $('select[name="ingredient_id_select[]"]').each(function (i) {
                            $(this).find('optgroup:first').append('<option ' +
                                'data-context="ingredient" ' +
                                'data-quantity="' + response.obj.quantity + '" ' +
                                'data-unit="' + response.obj.unit + '" ' +
                                'data-price="' + response.obj.price + '" ' +
                                'value="' + response.obj.id + '">' + response.obj.name + '</option>');
                        });

                        //Add new ingredient row with new ing selected
                        if ($('.ingredient-container').length) {
                            var $row = add_ingredient_row();
                        } else if ($('.stocktake-container').length) {
                            var $row = add_stocktake_ingredient_row();
                        }
                        $row.find('select[name="ingredient_id_select[]"]').val(response.obj.id).trigger('change');

                        //Trigger updates for all our selects
                        $('select[name="ingredient_id_select[]').trigger('chosen:updated');

                        //Reset form once submitted successfully
                        $form[0].reset();

                        //Close modal
                        $('.custom-modal, .custom-modal__overlay').fadeOut(300);

                        //Delete it
                        $('.ingredient-popup').remove();

                    //For ingredient EDIT pop-up form only... (from within recipe page)
                    } else if(context === 'popup-edit-ingredient-form' && response.body) {

                        //Update ingredient in all dropdowns on this page
                        $('select[name="ingredient_id_select[]"]').each(function(i) {
                            var isCurrent = $(this).val() === response.obj.id;

                            $(this).find('option[data-context="ingredient"][value="' + response.obj.id + '"]').replaceWith('<option ' +
                                'data-context="ingredient" ' +
                                'data-quantity="' + response.obj.quantity + '" ' +
                                'data-unit="' + response.obj.unit + '" ' +
                                'data-price="' + response.obj.price + '" ' +
                                'value="' + response.obj.id + '">' + response.obj.name + '</option>');

                            //If this select had the edited ing chosen
                            if(isCurrent) {

                                //Get old selections for other fields
                                var $row = $(this).closest('.row');
                                var $wastage = $row.find('select[name="ingredient_wastage_id[]"]');
                                var $unit = $row.find('select[name="ingredient_unit[]"]');

                                //Reselect the values they chose (including this ing)
                                $(this).val(response.obj.id);

                                //Set prev values data attr so we can pass to getter function later
                                $wastage.attr('data-prev-value', $wastage.val());
                                $unit.attr('data-prev-value', $unit.val());

                                //Reload wastages/units etc (will look for prev-value to set value)
                                $(this).trigger('change');

                            }
                        });

                        //Trigger updates for all our selects
                        $('select[name="ingredient_id_select[]').trigger('chosen:updated');

                        //Reset form once submitted successfully
                        $form[0].reset();

                        //Close modal
                        $('.custom-modal, .custom-modal__overlay').fadeOut(300);

                        //Delete it
                        $('.ingredient-edit-popup').remove();

                    //For recipe form only...
                    } else if(context === 'edit-recipe-form') {

                        //Set recipe_ingredient_id's for new ingredients added
                        if(response.ingredient_ids && response.ingredient_ids.length > 0) {
                            for(var i = 0; i < response.ingredient_ids.length; i++) {
                                var el = $('.recipe-ingredient-row.visible input[name="recipe_ingredient_id[]"]')[i];
                                if(el.value <= 0) {
                                    el.value = response.ingredient_ids[i];
                                }
                            }
                        }

                        //Pricing
                        $('.recipe-cost').html("...");
                        $('.recipe-gross-profit').html("...");
                        $('.recipe-profit-amount').html("...");

                        //Get updated cost/pricing info
                        ajax_call('get', '/admin/get_recipe_prices/' + response.body, {}, function(resp) {
                            $('.recipe-cost').html(resp.content.price);
                            $('.recipe-gross-profit').html(resp.content.gross_profit);
                            $('.recipe-tax').html(resp.content.tax);
                            $('.recipe-profit-amount').html(resp.content.profit_amount);

                            if(resp.content.tax_applied) {
                                $('.recipe-tax, .recipe-gross-profit, .recipe-profit-amount').addClass('tax--applied');
                            } else {
                                $('.recipe-tax, .recipe-gross-profit, .recipe-profit-amount').removeClass('tax--applied');
                            }
                        });

                    } else if(context === 'edit-menu-form') {

                        //Set menu_recipe_id's for new recipes added
                        if(response.recipe_ids && response.recipe_ids.length > 0) {
                            for(var i = 0; i < response.recipe_ids.length; i++) {
                                var el = $('.menu-recipe-row.visible input[name="menu_recipe_id[]"]')[i];
                                if(el.value <= 0) {
                                    el.value = response.recipe_ids[i];
                                }
                            }
                        }

                        //Pricing
                        $('.menu-cost').html("...");
                        $('.menu-gross-profit').html("...");
                        $('.menu-cost-per-person').html("...");
                        $('.menu-profit-amount').html("...");

                        //Get updated cost/pricing info
                        ajax_call('get', '/admin/get_menu_prices/' + response.body.id, {}, function(resp) {
                            $('.menu-cost').html(resp.content.price);
                            $('.menu-gross-profit').html(resp.content.gross_profit);
                            $('.menu-cost-per-person').html(resp.content.cost_per_person);
                            $('.menu-profit-amount').html(resp.content.profit_amount);
                        });

                    } else if(context === 'edit-stocktake-form') {

                        //Set stocktake_ingredient_id's for new ingredients added
                        if (response.ingredient_ids && response.ingredient_ids.length > 0) {
                            for (var i = 0; i < response.ingredient_ids.length; i++) {
                                var el = $('.stocktake-ingredient-row.visible input[name="stocktake_ingredient_id[]"]')[i];
                                if (el.value <= 0) {
                                    el.value = response.ingredient_ids[i];
                                }
                            }
                        }

                        //Pricing
                        $('.stocktake-cost').html("...");
                        $('.ingredient-count').html("...");

                        //Get updated cost/pricing info
                        ajax_call('get', '/admin/get_stocktake_prices/' + response.body.id, {}, function(resp) {
                            $('.stocktake-cost').html(resp.content.price);
                            $('.ingredient-count').html(resp.content.ingredient_count);
                        });

                    } else if(context === 'contact-support') {

                        $form.find('#message').val('');

                    }

                    //Scroll to top of page
                    scroll_to_pos(0, 500);

                    //Show success form alert message
                    show_alert(true, response.message, $form.closest('.content'));
                }

            //Otherwise there's an error
            } else {

                //Show form alert with error message/s
                show_alert(false, response.message, $form.closest('.content'));

                //If there are error fields reported...
                if(response.errors) {

                    var errors = response.errors;

                    //Loop over invalid field names
                    for(var field_name in errors) {
                        if(errors.hasOwnProperty(field_name)) {

                            //If it's a regular single field, add error class
                            if(field_name.indexOf('[]') === -1) {
                                $('[name="' + field_name + '"], #' + field_name + '_chosen, [name="' + field_name + '_select[]"]').addClass('field-error');

                            //Otherwise if it's an array field...
                            } else {

                                //Get error row index
                                var indexes = response.error_indexes;

                                //Get error row and field name
                                for(var row in indexes) {
                                    if(indexes.hasOwnProperty(row)) {

                                        //Get the field object
                                        var field = indexes[row];

                                        //Find appropriate row (we +1 because cloneable row will be found first)
                                        var error_row = $('input[name="' + field_name + '"]')[parseInt(field.index)+1];
                                        var $error_row = $(error_row).closest('.row.visible');

                                        if($error_row.length) {
                                            $error_row.find('[name="' + field.field + '[]"], #' + field.field + '_chosen, #' + field.field + '__chosen, #' + field.field + '___chosen, [name="' + field.field + '_select[]"]').addClass('field-error');
                                        }

                                    }
                                }

                            }

                        }
                    }

                    var error_pos = 0;

                    //If we have indexed errors, scroll to specific error, otherwise we just scroll top
                    if(response.error_indexes) {

                        //Get position of first error element
                        error_pos = $('.field-error:visible').first().offset().top;
                    }

                    //Scroll to it (minus some padding)
                    scroll_to_pos(Math.max(error_pos - 40, 0), 500);


                } else {

                    //Scroll to top of page
                    scroll_to_pos(0, 500);

                }

            }

        });

    });

    //Listing filter submit
    $body.on('submit', '.listing-filter', function(e) {
        e.preventDefault();

        var data = get_listing_data(1);
        get_listing(data);

        return false;

    });

    //Pagination item clicked
    $body.on('click', '.pagination .pagination__item a', function(e) {
        e.preventDefault();

        var data = get_listing_data($(this).data('ci-pagination-page'));
        get_listing(data);

        return false;

    });

    //Pagination item clicked
    $body.on('click', '.table-row--sortable', function(e) {
        e.preventDefault();

        //Update sort order
        update_sorted($(this));

        var data = get_listing_data();
        get_listing(data);

        return false;
    });

    //Update measurements on change
    //NB: Only listen for this AFTER we trigger change event above!
    $('#edit-ingredient-form, #edit-recipe-form, #edit-menu-form, #edit-supplier-form, #edit-stocktake-form, #edit-settings-form')
    .on('change', 'input, select, textarea, input[name="menu_date_alt"]', function(e) {
        unsaved = true;
    });

    //Warn them if trying to leave the page with unsaved changes
    if(window.addEventListener) {

        window.addEventListener("beforeunload", function (e) {
            if(unsaved) {
                var confirmationMessage = lang['error_unsaved_changes'];
                (e || window.event).returnValue = confirmationMessage;
                return confirmationMessage;
            }
        });

    } else {

        window.attachEvent("onbeforeunload", function (e) {
            if(unsaved) {
                var confirmationMessage = lang['error_unsaved_changes'];
                (e || window.event).returnValue = confirmationMessage;
                return confirmationMessage;
            }
        });

    }

});
